import { Component } from '@angular/core';
import { HeroComponent } from "../hero/hero.component";
import { FeturedProductsComponent } from '../fetured-products/fetured-products.component';
import { BenifitsComponent } from '../benifits/benifits.component';
import { CallToActionComponent } from '../call-to-action/call-to-action.component';
import { TestimonialsComponent } from '../testimonials/testimonials.component';

@Component({
  selector: 'app-home',
  imports: [HeroComponent, FeturedProductsComponent, BenifitsComponent, CallToActionComponent, TestimonialsComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
